import { storeOrUpdateMediaAccounts } from '@/api/media-account'
import { getMedias, getMediaTypes } from '@/api/constant'
import { getAdmins, getDeveloperAccounts } from '@/api/open'

export default {
    components: {},
    props: {
        showForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            labelCol: {span: 5},
            wrapperCol: {span: 17},
            medias: [],
            admins: [],
            developerAccounts: [],
            loading: false,
            rules: {
                name: [{required: true, message: '请输入账号名称', trigger: 'change'}],
                media: [{required: true, message: '请选择投放媒体', trigger: 'change'}],
                media_type: [{required: true, message: '请选择代理商', trigger: 'change'}],
                "settings.app_id": [{required: true, message: '请输入AppId', trigger: 'change'}],
                "settings.secret": [{required: true, message: '请输入Secret', trigger: 'change'}],
                "settings.secret_key": [{required: true, message: '请输入secretKey', trigger: 'change'}],
                "settings.app_access_token": [{required: true, message: '请输入AccessToken', trigger: 'change'}],
                "settings.scope": [{required: true, message: '请输入Scope', trigger: 'change'}],
                "settings.client_id": [{required: true, message: '请输入ClientId', trigger: 'change'}],
                "settings.client_secret": [{required: true, message: '请输入ClientSecret', trigger: 'change'}],
                "settings.username": [{required: true, message: '请输入账号', trigger: 'change'}],
                "settings.password": [{required: true, message: '请输入Password', trigger: 'change'}],
                "settings.api_key": [{required: true, message: '请输入ApiKey', trigger: 'change'}],
            },
            replaceFields: {
                title: 'name',
                key: 'id',
                value: 'id'
            },
            super_or_main: false,
            mediaTypes: [],
            payTypes: [{id:1,name:'付费'},{id:2,name:'免费'}],
            businessTypes: [{id:1,name:'快手分销'},{id:2,name:'快手番茄代投'}],
            // 开放平台类型 1-磁力引擎 2-短剧经营者
            openPlatformTypes: [{id:1,name:'磁力引擎'},{id:2,name:'短剧经营者'}],
        }
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '添加'
        },
    },
    mounted() {
        getMedias().then(res => {this.medias = res.data.list || []})
        getMediaTypes().then(res => {this.mediaTypes = res.data.list || []})
        getAdmins().then(res => {this.admins = res.data.list || []})
        getDeveloperAccounts().then(res=>{ 
            this.developerAccounts = res.data.list || {} 
            this.super_or_main = res.data.super_or_main || false 
        })
    },
    watch: {},
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        changeMedia() {
            switch (true) {
                case [1, 2].includes(this.model.media):
                    this.model.settings = {
                        app_id: '',
                        secret: '',
                        scope: ''
                    }
                    this.model.settings.scope = this.model.media === 2
                        ? '10000000,2,3,4,5,8,9,10,12,13,14,11000000'
                        : 'account_service,ad_manage,report_service,ad_query'
                    // 短剧经营者平台固定使用 ad_series，避免沿用磁力引擎 scope 导致授权范围不对
                    if (this.model.open_platform_type === 2) {
                        this.model.settings.scope = 'ad_series'
                    }
                    break
                case this.model.media === 3:
                    this.model.settings.scope = '65,66,67,68,69,70,1009333,1009334,71,72,1009335,74,75,73,1001455,1001788'
                    break;
            }
            this.$refs['form'].clearValidate([
                'name',
                'media',
                'corporation_id',
                'settings.app_id',
                'settings.secret',
                'settings.scope',
                'settings.client_id',
                'settings.client_secret',
                'settings.username',
                'settings.password',
                'settings.api_key',
                'settings.secret_key',
            ])
        },
        /**
         * 切换开放平台类型：选「短剧经营者」时把 scope 自动置为 ad_series
         */
        changeOpenPlatformType(value) {
            if (value !== 2 || this.model.media !== 1) {
                return
            }
            this.model.settings = this.model.settings || {}
            this.model.settings.scope = 'ad_series'
        },
        storeOrUpdate() {
            const data = Object.assign({}, this.model)
            this.loading = true
            storeOrUpdateMediaAccounts(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success(this.model.id > 0 ? '修改成功' : '添加成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showForm', false)
        }
    }
}
